// VSB: collection grid. "Load more" is a real link to the next page (?page=N): with scripts
// on, that page's cards are fetched through the Section Rendering API and added to this
// grid, and the paging (its progress line, its next link) is replaced by the fetched one.
// Focus moves to the first new card, and the progress line (role=status) announces the
// count. Bound on the document, so it survives Dawn's facets.js replacing the grid.
(() => {
  if (window.vsbCollectionGrid) return;
  window.vsbCollectionGrid = true;

  // "Only the useful sorts": alphabetical and oldest-first leave the sort menus (Dawn
  // re-renders them after each filter change, so they are trimmed again then).
  const HIDDEN_SORTS = ['title-ascending', 'title-descending', 'created-ascending'];
  const trimSorts = () => {
    for (const grid of document.querySelectorAll('.vsb-cg[data-hide-sorts]')) {
      for (const option of grid.querySelectorAll('select[name="sort_by"] option')) {
        if (HIDDEN_SORTS.includes(option.value) && !option.selected) option.remove();
      }
    }
  };
  const watch = () => {
    trimSorts();
    for (const grid of document.querySelectorAll('.vsb-cg[data-hide-sorts]')) new MutationObserver(trimSorts).observe(grid, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  document.addEventListener('click', async (event) => {
    const more = event.target.closest('a[data-more]');
    if (!more || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    const container = more.closest('#ProductGridContainer');
    const grid = container && container.querySelector('#product-grid');
    if (!grid) return;
    event.preventDefault();
    if (more.getAttribute('aria-busy') === 'true') return;
    more.setAttribute('aria-busy', 'true');
    try {
      const url = new URL(more.href, window.location.href);
      url.searchParams.set('section_id', more.dataset.more);
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(String(response.status));
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const items = [...html.querySelectorAll('#product-grid > li')];
      const firstNew = items[0];
      for (const item of items) grid.append(document.adoptNode(item));
      const paging = container.querySelector('[data-paging]');
      const nextPaging = html.querySelector('[data-paging]');
      if (paging && nextPaging) paging.replaceWith(document.adoptNode(nextPaging));
      else if (paging) paging.remove();
      const link = firstNew && firstNew.querySelector('.vsb-gc__title a, a');
      if (link) link.focus({ preventScroll: true });
    } catch (e) {
      // Leave the page by the link itself: the next page renders on its own.
      window.location.href = more.href;
    } finally {
      more.removeAttribute('aria-busy');
    }
  });
})();
